import type { ManualClaimTx } from "../../state/types";
import { ManualClaimFailModal } from "./ManualClaimFailModal";
import { ManualClaimSuccessModal } from "./ManualClaimSuccessModal";

export function ManualClaimResultModal({
  isOpen,
  onClose,
  onRetry,
  claimTx,
}: {
  isOpen: boolean;
  onClose: () => void;
  onRetry: () => void;
  claimTx: ManualClaimTx | null;
}) {
  if (!claimTx) return null;
  if (claimTx.success) {
    return <ManualClaimSuccessModal isOpen={isOpen} onClose={onClose} claimTx={claimTx} />;
  }
  return <ManualClaimFailModal isOpen={isOpen} onClose={onClose} onRetry={onRetry} claimTx={claimTx} />;
}
